var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-modal',{staticClass:"kst-invoice-item-search",attrs:{"width":800,"active":_vm.active,"title":_vm.title},on:{"cancel":_vm.handleModal_Cancel,"submit":_vm.handleModal_Submit}},[_c('kst-subtitle',[_vm._v(_vm._s(_vm.subTitle))]),_c('List',{attrs:{"items":_vm.items,"userData":_vm.userData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }